import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import { getAnalysisInfoLines } from '../../helpers/analysisListHelpers'
import { GameAnalysis } from '../../types/GameAnalyses'

type AnalysisInfoSummaryProps = {
  analysis: GameAnalysis
  positionName?: string
}

export const AnalysisInfoSummary: FC<AnalysisInfoSummaryProps> = ({ analysis, positionName }) => {
  const { t } = useTranslation()

  return (
    <Box component="ul" sx={{ m: 0, pl: 2 }}>
      {getAnalysisInfoLines(analysis).map(({ action, at, by, isSystem }) => (
        <Typography component="li" variant="body2" key={action}>
          {t(`internal-analysts:games_analyses_info_${action}`, { at, by: isSystem ? t('internal-analysts:games_analyses_system') : by })}
        </Typography>
      ))}
      <Typography component="li" variant="body2">
        {t('internal-analysts:games_analyses_info_position', { position: positionName ?? '---' })}
      </Typography>
    </Box>
  )
}
